import React from "react";
import { useNavigate } from "react-router-dom";
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';
import "./Kinder.css";

function Kinder() {
  const navigate = useNavigate();

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title kinder">Kinder Verwalten</h1>
        <div className="button-container">
          <button className="button_boring_red kinder" onClick={() => navigate("/kinderverwaltung")}>
            <span className="material-symbols-outlined">group</span>
            Kinder verwalten
          </button>
          <button className="button_boring_red kinder" onClick={() => navigate("/kindhinzufuegen")}>
            <span className="material-symbols-outlined">emoji_people</span>
            Kind hinzufügen
          </button>
          <button className="button_boring_red kinder" onClick={() => navigate("/kind_saltyscore")}>
            <span className="material-symbols-outlined">sentiment_dissatisfied</span>
            Salty Score
          </button>
        </div>
      </div>
    </KernteamLayout>
  );
}

export default Kinder;
